import React, { useState, useEffect } from 'react';
import {
  Box,
  IconButton,
  Popover,
  Typography,
  MenuItem,
  Select,
} from '@mui/material';

import { CalendarToday, RestartAlt } from '@mui/icons-material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';

const years = [2025, 2024, 2023, 2022];

const DeadlineFilterPopover = ({
  selectedYear,
  setSelectedYear,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleReset = () => {
    setSelectedYear(null);
    setStartDate(null);
    setEndDate(null);
  };

  useEffect(() => {
    if (selectedYear) {
      const jan1 = new Date(selectedYear, 0, 1);
      const dec31 = new Date(selectedYear, 11, 31, 23, 59, 59);
      setStartDate(jan1);
      setEndDate(dec31);
    }
  }, [selectedYear]);

  return (
    <>
      <IconButton
        onClick={handleClick}
        size="small"
        sx={{
          borderRadius: '50%',
          padding: '4px',
          color: 'black',
          backgroundColor:
            selectedYear || startDate || endDate
              ? 'primary.light'
              : 'transparent',
        }}
      >
        <CalendarToday fontSize="small" />
      </IconButton>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        PaperProps={{ sx: { p: 2, width: 200, position: 'relative' } }} // Added position: relative
      >
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={1}
          >
            <Typography fontWeight="bold">Année</Typography>
            <IconButton
              onClick={handleReset}
              size="small"
              sx={{
                color: 'grey.600',
                padding: 0,
              }}
            >
              <RestartAlt fontSize="small" />
            </IconButton>
          </Box>
          <Select
            value={selectedYear || ''}
            onChange={(e) => setSelectedYear(Number(e.target.value))}
            fullWidth
            size="small"
          >
            {years.map((year) => (
              <MenuItem key={year} value={year}>
                {year}
              </MenuItem>
            ))}
          </Select>

          <Box>
            <Typography fontWeight="bold" gutterBottom>
              Intervalles
            </Typography>
            <DatePicker
              label="Date début"
              value={startDate}
              onChange={(newValue) => setStartDate(newValue)}
              slotProps={{ textField: { size: 'small', fullWidth: true } }}
            />
            <Box mt={1} />
            <DatePicker
              label="Date de fin"
              value={endDate}
              onChange={(newValue) => setEndDate(newValue)}
              slotProps={{ textField: { size: 'small', fullWidth: true } }}
            />
          </Box>
        </LocalizationProvider>
      </Popover>
    </>
  );
};

export default DeadlineFilterPopover;
